import { render, staticRenderFns } from "./recruitment-notice-detail.vue?vue&type=template&id=34148dbc&scoped=true&"
import script from "./recruitment-notice-detail.vue?vue&type=script&lang=js&"
export * from "./recruitment-notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./recruitment-notice-detail.vue?vue&type=style&index=0&id=34148dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34148dbc",
  null
  
)

export default component.exports